import queryString from 'query-string';
import { ROUTE } from './constants';

export const navigateToHome = () => {
  window.location.href = ROUTE.ROOT;
};

export const navigateToSearch = filter => {
  if (filter) {
    const { languageId } = filter;
    const locale = languageId.replace('-', '/');
    const params = queryString.stringify({
      adults: filter.adults,
      children: filter.children,
      checkin: filter.checkin,
      checkout: filter.checkout,
      locationId: filter.locationId,
    });
    window.location.href = `${ROUTE.HOTEL.SEARCH_WIDGET}/${locale}?${params}`;
  } else {
    window.location.href = ROUTE.HOTEL.SEARCH_WIDGET;
  }
};

export const navigateToExternalLink = destinationUrl => {
  window.location = destinationUrl;
};
